import React, { ReactElement } from 'react';

import styles from './PageTitle.module.scss';

interface IPageTitleProps {
	title: string;
	icon?: ReactElement;
}

const PageTitle = ({
	title,
	icon,
}: IPageTitleProps) => {
	return (
		<div
			className={styles.pageTitleContainer}
			data-testid='page-title-container'
		>
			{icon
				&& <div className={styles.icon}>
					{icon}
				</div>
			}
			<div
				className={styles.title}
				data-testid='page-title'
			>
				{title}
			</div>
		</div>
	);
};

export default PageTitle;
